import { render, staticRenderFns } from "./car-slider-desk-vertical.vue?vue&type=template&id=57001bba&"
import script from "./car-slider-desk-vertical.vue?vue&type=script&lang=js&"
export * from "./car-slider-desk-vertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonFavorite: require('/var/www/components/button/button-favorite.vue').default,PictureComponent: require('/var/www/components/picture/picture-component.vue').default})
